import {Component, Input, forwardRef, OnInit, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor,  NG_VALUE_ACCESSOR } from '@angular/forms';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ModalsService } from '../../services/modals/modals.service';
import { USER_ROLES } from '../../constants/api-constants';

@Component({
  selector: 'app-selectable-list-items',
  templateUrl: './selectable-list-items.component.html',
  styleUrls: ['./selectable-list-items.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectableListItemsComponent),
      multi: true
    }
  ]
})
export class SelectableListItemsComponent implements OnInit, ControlValueAccessor {
  @Input() addButtonText: string = 'Add Items';
  @Input() showDefaultActionButton: boolean = true;

  listOfItems: any[] = [];
  allSelected: boolean = false;

  private onChange = (_: any) => { };
  private onTouched = () => { };

  role:any;
  USER_ROLES = USER_ROLES;

  @Output() setDefaultEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() removeDefaultEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor(private _modalPopupService: ModalsService) { }

  ngOnInit() {
    this.role = localStorage.getItem('Role');
    this.updateAllSelectedState();
  }

  // ControlValueAccessor methods
  writeValue(value: any[]): void {
    this.listOfItems = value || [];
    this.updateAllSelectedState();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Handle disabled state if needed
  }

  emitChanges() {
    this.onChange(this.listOfItems);
    this.onTouched();
  }

  openMultiPointModal() {
    this._modalPopupService.openMultiPointInput().then(modal => {
      modal.onWillDismiss().then(result => {
        if (result.data) {
          this.addPoints(result.data);
        }
      });
    });
  }

  addPoints(points: any) {
    const data = points
      .trim()
      .split('\n')
      .filter((str: string) => str.trim() !== '');
    if (data instanceof Array) {
      data.forEach(element => {
        this.listOfItems.push({
          key: `IMP${this.listOfItems.length + 1}`,
          name: element,
          checked: true,
          addedByUser: true
        });
      });
      this.emitChanges();
    }
  }

  checkListItem(index: number, flag: boolean) {
    this.listOfItems[index].checked = !flag;
    this.updateAllSelectedState();
    this.emitChanges();
  }

  deleteItem(index: number) {
    this.listOfItems.splice(index, 1);
    this.emitChanges();
  }

  toggleSelectAll(event: any): void {
    const isChecked = event.target.checked;
    this.allSelected = isChecked;
    this.listOfItems.forEach(item => (item.checked = isChecked));
    this.emitChanges();
  }

  updateAllSelectedState(): void {
    this.allSelected = this.listOfItems.every(item => item.checked);
  }

  positionOfItemChanged(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.listOfItems, event.previousIndex, event.currentIndex);
    this.emitChanges();
  }

  itemInputTextChanged(){
    this.emitChanges();
  }

  setDefault(item:any){
    this.setDefaultEmitter.emit(item);
  }
  removeDefault(item:any){
    this.removeDefaultEmitter.emit(item);
  }
}
